import { imageUrl } from '@frontend/components/image-groups/image-group-utils';

export function brandGuidelineThumbnailUrl(guideline, { lightweight = true } = {}) {
  if (!guideline) {
    return '';
  }

  const raw = guideline.thumbnail_url || (guideline.thumbnail ? `/share?file=${guideline.thumbnail}` : '');
  if (!raw) {
    return '';
  }

  const resolved = imageUrl({ url: raw });
  if (!resolved) {
    return '';
  }

  if (!lightweight) {
    return resolved;
  }

  const separator = resolved.includes('?') ? '&' : '?';
  return `${resolved}${separator}lightweight=1&scale_width=300`;
}
